import React from "react";
import "./styles.css";
import Container from "../Common/Container";
import Text from "../Common/Text";

const DEFAULDATA = {
  html: `<h1>Bienvenido a Dogtorsoftware</h1>\n<p>Dogtorsoftware es tu soluci&oacute;n ideal para gestionar y optimizar el contenido de tu sitio web de forma sencilla. Ya seas blogger, empresario o desarrollador web, nuestro CMS te ofrece herramientas intuitivas para crear, editar y publicar contenido de manera eficiente.</p>\n<h2>Destacamos por:</h2>\n<ol>\n<li><strong>Edici&oacute;n Intuitiva:</strong> Actualiza tu contenido f&aacute;cilmente sin necesidad de habilidades t&eacute;cnicas avanzadas.</li>\n<li><strong>Dise&ntilde;o Responsivo:</strong> Tu sitio lucir&aacute; genial en cualquier dispositivo, desde m&oacute;viles hasta pantallas de escritorio.</li>\n<li><strong>Gesti&oacute;n Multimedia:</strong> Organiza im&aacute;genes, videos y archivos multimedia de manera eficaz para una experiencia visual atractiva.</li>\n<li><strong>SEO Integrado:</strong> Mejora tu visibilidad en buscadores con nuestras herramientas de optimizaci&oacute;n.</li>\n<li><strong>Seguridad Prioritaria:</strong> Incorporamos medidas robustas para proteger tu contenido y la informaci&oacute;n de tus usuarios.</li>\n</ol>\n<p><strong>&iexcl;Descubre lo que Dogtorsoftware puede hacer por ti!</strong></p>`,
};
const Html = ({ data = DEFAULDATA, onChange }: any) => {
  return (
    <Container className="my-10">
      <Text
        editor={!!onChange}
        id="Html"
        onChange={(val: any) => onChange?.(val, "html")}
      >
        {data.html}
      </Text>
    </Container>
  );
};

export default Html;
